import React from 'react'

import { useAbandonedCheckoutRemindersSettings } from '@modules/Dashboard/pages/Settings/pages/Checkout/hooks/useAbandonedCheckoutRemindersSettings'

import { MailchimpAudienceConnected } from './components/MailchimpAudienceConnected'
import { MailchimpCreateStore } from './components/MailchimpCreateStore'
import { MailchimpGetStarted } from './components/MailchimpGetStarted'
import { MailchimpStoreConnected } from './components/MailchimpStoreConnected'
import { MailchimpSyncJobActive } from './components/MailchimpSyncJobActive'
import { useMailchimp } from './hooks/useMailchimp'

const DEFAULT_SYNC_JOB_KEYS = [
  'MEMBERS' as const,
  'NEWSLETTER' as const,
  'OFFERS' as const,
  'PROMOTIONS' as const,
]

const LIST_SYNC_JOB_KEYS = ['MEMBERS' as const, 'NEWSLETTER' as const]

export const AppsMailchimpSettings = () => {
  const {
    mailchimp,
    syncStatus,
    // actions
    refreshLists,
    isRefreshing,
    createStore,
    isCreatingStore,
    createSyncJob,
    isCreatingSyncJob,
  } = useMailchimp()

  const { abandonedCheckoutRemindersSettings } = useAbandonedCheckoutRemindersSettings()
  const isOff =
    abandonedCheckoutRemindersSettings.initialValues.abandonedCheckoutEmailFrequency === 'off'

  if (!mailchimp.configuration) {
    return <div>Loading...</div>
  }

  // Show get started button if fetchedLists is false
  if (!mailchimp.configuration.fetchedLists || !mailchimp.configuration.lists) {
    return <MailchimpGetStarted refreshLists={refreshLists} isRefreshing={isRefreshing} />
  }

  if (!mailchimp.configuration.listId) {
    return (
      <MailchimpCreateStore
        lists={mailchimp.configuration.lists}
        createStore={createStore}
        isCreatingStore={isCreatingStore}
        refreshLists={refreshLists}
        isRefreshing={isRefreshing}
      />
    )
  }

  if (syncStatus.active) {
    return <MailchimpSyncJobActive status={syncStatus.progress} />
  }

  if (mailchimp.configuration.hasStore) {
    return (
      <MailchimpStoreConnected
        createSyncJob={() => createSyncJob({ keys: DEFAULT_SYNC_JOB_KEYS })}
        isCreatingSyncJob={isCreatingSyncJob}
        hasSynced={syncStatus.hasSynced}
        recentSync={syncStatus.recent}
        abandonedCheckoutIsOff={isOff}
        dataCount={mailchimp.configuration.dataCount ?? 0}
      />
    )
  }

  return (
    <MailchimpAudienceConnected
      listId={mailchimp.configuration.listId}
      createStore={createStore}
      isCreatingStore={isCreatingStore}
      createSyncJob={() => createSyncJob({ keys: LIST_SYNC_JOB_KEYS })}
      isCreatingSyncJob={isCreatingSyncJob}
      hasSynced={syncStatus.hasSynced}
      recentSync={syncStatus.recent}
      abandonedCheckoutIsOff={isOff}
      dataCount={mailchimp.configuration.dataCount ?? 0}
    />
  )
}
